<template>
	<div>
		<div class="input-select" v-if="!product">
			<p>
				Busque por nombre y/o principio activo
			</p>

			<div class="search">
				<div class="search-input">
					<input type="text" @input="search" v-model="searchText" ref="searchInput" autofocus />
					<i class="icon icon-search"></i>
				</div>

				<div class="option-dropdown" v-if="amps.length > 0 || vmps.length > 0">
					<div class="option-subtitle" v-if="amps.length > 0">MEDICAMENTOS COMERCIALES</div>
					<div class="item" v-for="option in amps" :key="option.id" @click="selectAMP(option)">
						<div>
							{{ option.labName }}<br />
							<strong>{{ option.name }}</strong>
							<div class="text-secondary">
								<span v-for="(droug, i) in option.substances" :key="i" style="margin-right:6px">{{ droug.name }}</span>
							</div>
						</div>
					</div>

					<div class="option-subtitle" v-if="vmps.length > 0">MEDICAMENTOS GENERICOS</div>
					<div class="item" v-for="option in vmps" :key="option.VMP_Id" @click="selectVMP(option)">
						<div>
							<strong>{{ option.name }}</strong>
							<div class="text-secondary">
								<span v-for="(droug, i) in option.substances" :key="i">{{ droug.name }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="product-detail" v-if="product">
			<ProductCard :product="product" class="mt-2" />

			<FormulateForm ref="form" v-model="form" @submit="save">
				<div class="mt-3 dosification">
					<div class="d-flex align-items-center">
						<FormulateInput label="Indicaciones" name="dose" type="number" validation-name="Unidad" min="0" class="m-0" style="width:80px" />
						<div class="mt-3 ml-2">{{ product.dosificationUnit }}</div>
					</div>
					<small class="text-secondary mb-2">*Para fraccionar ingrese decimales. Ej: 1 comp y medio = 1.5</small>

					<FormulateInput label="cada" name="frecuency" :options="{ HOUR: 'Horas', DAYS: 'Dias', WEEK: 'Semanas' }" type="keyValue" min="0" validation-name="Frecuencia" class="m-0 mb-2" />
					<FormulateInput label="durante" name="duration" :options="{ HOUR: 'Horas', DAYS: 'Dias', WEEK: 'Semanas' }" type="keyValue" min="0" validation-name="Duración" class="m-0 mb-2" />
				</div>

				<button class="mt-4 mb-2 cursor-pointer" type="button" @click="()=>{collapsed = !collapsed}">
					<span v-if="collapsed">Mostrar datos adicionales <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
  						<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>
					</span>
					<span v-else>Ocultar datos adicionales <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
  						<path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/></svg>
					</span>
				</button>
				<div v-show="!collapsed" >

					<FormulateInput class="mt-2" label="Afecciones" type="textarea" name="affections" help="(opcional)" />

					<FormulateInput class="mt-2" label="Antecedentes" type="textarea" name="medicalHistory" help="(opcional)" />

					<FormulateInput class="mt-2" label="Fecha límite para dispensar" name="expireAt" type="date" :min="today" help="(opcional)" />
				</div>

				

				<div class="d-flex justify-content-end mt-4">
					<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader"/></FormulateInput>
					<FormulateInput type="submit" label="Agregar" v-else />
				</div>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"
import ProductCard from "@/views/products/ProductCard"
import axios from "axios"

export default {
	name: "PrescribeMedicineForm",
	components: { ProductCard },
	data() {
		return {
			searchText: "",
			loading: true,
			amps: [],
			vmps: [],
			doseOptions: [],
			collapsed: true,
			product: null,
			today: this.$moment().format("YYYY-MM-DD"),
			form: {
				qty: 1,
				dose: 1,
				doseUnit: null,
				frecuency: { value: 8, option: "HOUR" },
				duration: { value: 8, option: "DAYS" },
				medicalHistory: null,
				affections: null,
				expireAt: this.$moment()
					.add(3, "month")
					.format("YYYY-MM-DD")
			}
		}
	},

	mounted() {
		// this.$refs.searchInput.$el.children[0].focus()
		this.$nextTick(() => this.$refs.searchInput.focus())
	},

	methods: {
		save() {
			console.log(this.form)
			this.$emit("created", { ...this.form, product: this.product })
		},

		async selectAMP(amp) {
			this.product = amp
			this.form.doseUnit = amp.dosificationUnit
			this.form.doseType = amp.dosificationType
		},
		async selectVMP(vmp) {
			
			this.product = vmp
			this.form.doseUnit = vmp.dosificationUnit
			this.form.doseType = vmp.dosificationType
		},

		search() {
			if (this.searchText != "") {
				this.$apollo
					.query({
						query: gql`
							query($take: Int, $skip: Int, $search: String) {
								products(take: $take, skip: $skip, search: $search) {
									data {
										id
										type
										name
										labName
										substances {
											name
											dosif
											unit
										}
										dosificationUnit
										dosificationType
									}
									pageInfo {
										totalItems
									}
								}
							}
						`,
						variables: {
							take: 300,
							skip: 0,
							search: this.searchText
						},
						fetchPolicy: "no-cache"
					})
					.then(data => {
						console.log(data)
						// order data.data.products placing first the items with labName= Megalabs, Roemmers, Nestle, Celsius, Spefar, Haymann, Servimedic or Dermur
						let products = data.data.products.data
						// let labs = ["Megalabs", "Medihealth", "Roemmers", "Nestle", "Celsius", "Spefar", "Haymann", "Servimedic", "Dermur"]
						// let orderedProducts = []

						// labs.forEach(lab => {
						// 	products.forEach(product => {
						// 		let found = labs.some(labName => product.labName.includes(labName));
						// 		if (found && product.labName.includes(lab)) {
						// 			orderedProducts.push(product)
						// 		}
						// 	})
						// })

						// products.forEach(product => {
						// 	if (!labs.some(labName => product.labName.includes(labName))) {
						// 		orderedProducts.push(product)
						// 	}
						// })
						
						this.amps = products.filter(item => item.type == "AMP")
						this.vmps = products.filter(item => item.type == "VMP")




						this.loading = false
					})

			}
		}
	}
}
</script>

<style scoped>
.search {
	position: relative;
}

.search-input {
	cursor: pointer;
	border-radius: 0.3em;
	color: #000;
	border: 1px solid #cecece;
	padding: 0px 10px;
	width: 100%;
	display: flex;
	align-items: center;
}
.search-input input:focus {
	border: none !important;
	outline: none !important;
}
.search-input input {
	height: 37px;
	color: #000;
	border: none;
	width: 100%;
}
.option-subtitle {
	padding: 8px;
	font-size: 11px;
	color: #fff;
	background-color: #00b3b6;
}
.option-dropdown {
	display: block;
	box-sizing: border-box;
	position: absolute;
	top: calc(100% - 1px);
	left: 0;
	z-index: 1000;
	padding: 5px 0;
	margin: 0;
	width: 100%;
	max-height: 350px;
	min-width: 160px;
	overflow-y: auto;
	-webkit-box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
	border: 1px solid rgba(60, 60, 60, 0.26);
	border-top-style: none;
	border-radius: 0 0 4px 4px;

	background-color: #fff;
}
.option-dropdown .item {
	border-bottom: 1px solid #d3d3d3;
	padding: 10px;
	line-height: 14px;
}
.option-dropdown .item strong {
	font-size: 13px;
}
.option-dropdown .item span {
	font-size: 13px;
}
.option-dropdown .item:hover {
	background-color: #f3f3f3;
	cursor: pointer;
}
/* .dosification /deep/ select {
	border: none !important;
	background-color: transparent !important;
	padding: 0px !important;
}
.dosification /deep/ input {
	border: none !important;
	background-color: transparent !important;
	padding: 0px !important;
}
.dosification > span {
	padding: 0px;
	min-height: 40px;
} */

.formulate-input[data-type="keyValue"] /deep/ input::-webkit-outer-spin-button,
.formulate-input[data-type="keyValue"] /deep/ input::-webkit-inner-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

/* Firefox */
.formulate-input[data-type="keyValue"] /deep/ input[type="number"] {
	-moz-appearance: textfield;
	padding: 0.75em 0.2em;
	text-align: center;
}
</style>
